import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

const XTwitter: React.FC<SvgProps> = ({ color, ...props }) => (
  <Svg
    width="27"
    height="28"
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <Path
      d="M16.0687 11.8561L26.12 0H23.7382L15.0106 10.2945L8.03988 0H0L10.5411 15.5671L0 28H2.38199L11.5985 17.1287L18.9601 28H27L16.0681 11.8561H16.0687ZM12.8062 15.7042L11.7382 14.1541L3.24025 1.81954H6.89884L13.7568 11.7739L14.8248 13.324L23.7393 26.2632H20.0807L12.8062 15.7048V15.7042Z"
      fill={color || '#000319'}
    />
  </Svg>
);

export default XTwitter;
